import t from "@/lang/lang";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import { TextInputField } from "@/shared/components/field/input-field";
import { CustomerAddressCard } from "@/services/backend/addresses/components/customer-address-card";
import { Information } from "../types/information";

/**
 * BillingInformationCard edits where and how invoices are sent, and the
 * address they are sent to. The fields are keyed `<fieldName>.<field>`.
 */
export function BillingInformationCard({
  billingInformation,
  onBillingInformationChange,
  fieldName = "billingInformation",
  disabled,
}: {
  billingInformation: Information;
  onBillingInformationChange: (billingInformation: Information) => void;
  fieldName?: string;
  disabled?: boolean;
}) {
  const change = (p: Partial<Information>) =>
    onBillingInformationChange({ ...billingInformation, ...p });

  return (
    <div className="grid gap-2">
      <Card>
        <CardHeader>
          <CardTitle>{t("Rechnungsversand")}</CardTitle>
          <CardDescription>
            {t("Wohin und wie Rechnungen geschickt werden.")}
          </CardDescription>
        </CardHeader>
        <CardContent className="grid gap-4 lg:grid-cols-2">
          <TextInputField
            label={t("Rechnungsformat")}
            text={billingInformation.invoiceFormat}
            onTextChange={(invoiceFormat) => change({ invoiceFormat })}
            placeholder="ZUGFeRD, X-Rechnung"
            fieldName={`${fieldName}.invoiceFormat`}
            disabled={disabled}
          />
          <TextInputField
            label={t("E-Mail für Rechnungen")}
            text={billingInformation.invoiceEmail}
            onTextChange={(invoiceEmail) => change({ invoiceEmail })}
            fieldName={`${fieldName}.invoiceEmail`}
            disabled={disabled}
          />
          <TextInputField
            label={t("Leitweg-ID")}
            text={billingInformation.leitwegId}
            onTextChange={(leitwegId) => change({ leitwegId })}
            fieldName={`${fieldName}.leitwegId`}
            fieldProps={{ className: "lg:col-span-2" }}
            disabled={disabled}
          />
        </CardContent>
      </Card>
      <CustomerAddressCard
        title={t("Rechnungsadresse")}
        customerAddress={billingInformation.invoiceAddress}
        onCustomerAddressChange={(invoiceAddress) => change({ invoiceAddress })}
        description={t("Adresse, an welche Rechnungen geschickt werden.")}
        fieldName={`${fieldName}.invoiceAddress`}
        disabled={disabled}
      />
    </div>
  );
}
